package kz.dentalcrm.app.screens.positions.edit.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.positions.Position

sealed interface EditPositionViewEvent : ViewEvent {
    data class EditPosition(val position: Position, val name: String, val description: String) : EditPositionViewEvent
    data class DeletePosition(val position: Position) : EditPositionViewEvent
    data object Reset : EditPositionViewEvent
}
